function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * @file 拦截xmlhttprequest对象
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util / interceptAjax
 */
import timeReport from '../time';
import { Config, HB_SESSION_ID_KEY, trackID, userID } from './config';
import extractPathname from './url';
import cookie from './cookie';
var BACKEND_API_GAPM_TRACEID = 'gapm-traceid'; // 全局取一次就好

var documentWidth = 0;
var documentHeight = 0;
var HB_SESSION_ID_VALUE = cookie.get(HB_SESSION_ID_KEY);

function canMakeHTTPRequest() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
}
/**
 * 是否可以拦截当前域名接口， 除了 Config.QINGZHOU_DOMAIN, Config.DOMAIN 之外，都需要拦截一下
 *
 * @param {string} 需要进行判断的url
 * @return {boolean} 是否不能拦截某些接口
 */


function canNotIntercept() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // Config.QINGZHOU_DOMAIN, Config.DOMAIN 域名不进行拦截
  return url.indexOf(Config.QINGZHOU_DOMAIN) > -1 || url.indexOf(Config.DOMAIN) > -1;
}
/**
 * 拦截接口请求，执行自定义的回调
 *
 * @param {Function} fn 回调函数
 */


export function interceptXHR(fn) {
  if (canMakeHTTPRequest()) {
    var open = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function xhropen() {
      var _this = this;

      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      var start = Date.now();
      var _params$ = params[1],
          url = _params$ === void 0 ? '' : _params$;

      var readyStateChangeListener = function readyStateChangeListener() {
        /**
         * 性能考虑，只有在xhr状态为 DONE 时，才进行后续的拦截上报操作。
         *
         * UNSENT（未发送）0
         * OPENED（已打开）1
         * HEADERS_RECEIVED () 2
         * LOADING（下载中）3
         * DONE（完成）4
         */
        // 为防止其他第三方脚本修改 XMLHttpRequest，比如oneapm，再从原型上取一下值
        if (_this.readyState === XMLHttpRequest.DONE || _this.readyState === XMLHttpRequest.prototype.DONE) {
          if (canNotIntercept(url)) {
            _this.removeEventListener('readystatechange', readyStateChangeListener);

            return;
          }

          var elapsed = Date.now() - start; // 将当前xhr 实例， open 方法的所有参数，和额外的数据（比如性能耗时信息，以后可以继续补充）传给回调函数

          if (typeof fn === 'function') {
            try {
              fn(_this, params, {
                start: start,
                elapsed: elapsed
              });
            } catch (e) {
              // eslint-disable-next-line no-console
              console.error('interceptXHR err', e);
            }
          }

          _this.removeEventListener('readystatechange', readyStateChangeListener);
        }
      };

      this.addEventListener('readystatechange', readyStateChangeListener);
      open.apply(this, params);
    };
  }
}
/**
 * 拦截fetch接口请求
 *
 * @param {Function} fn 处理fetch返回结果的回调函数
 */

export function interceptFetch(fn) {
  if (canMakeHTTPRequest()) {
    var oldFetch = fetch;

    window.fetch = function newfetch() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var start = Date.now();
      return oldFetch.apply(null, args).then(function (fetchResponse) {
        fn(fetchResponse, args, {
          start: start
        });
        return fetchResponse;
      }, function (fetchResponse) {
        // 接口由于网络失败，或者中断请求
        fn(fetchResponse, args, {
          start: start
        });
        return fetchResponse;
      });
    };
  }
}
/**
 * 拦截 XHR 接口请求后，执行自定义的回调
 *
 * @param {Object} xhrInstance XHR实例对象
 * @param {Array.<string>} apiParams 发起请求时带的参数
 * @param {number} elapsed 接口请求的耗时
 */

function handleXHR(xhrInstance, apiParams, _ref) {
  var start = _ref.start,
      elapsed = _ref.elapsed;
  // gapm traceid 是后端返回的用来跟踪每次接口请求链路的id，放在api接口的响应头里，往轻舟发起 api_call 类型请求的时候自动带上
  var apiCallTraceId = ''; // 提前判断一下响应头是否存在 BACKEND_API_GAPM_TRACEID，如果不存在，还用 getResponseHeader 获取，chrome上就会在控制台报错，但是这个错误不影响代码后续执行

  if (xhrInstance.getAllResponseHeaders().indexOf(BACKEND_API_GAPM_TRACEID) > -1) {
    apiCallTraceId = xhrInstance.getResponseHeader(BACKEND_API_GAPM_TRACEID);
  } // 要上报的数据


  var timingData = _objectSpread(_objectSpread({}, getBasicApiTimeData()), {}, {
    // 操作名，一般取接口路径 params为发起xhr 请求时，OPEN方法的所有参数
    // 举个例子 apiParams = ['GET', '/api/1', true]， apiParams[1] 就是请求的接口，过滤掉接口的query 部分
    actionName: extractPathname(apiParams[1]),
    actionStart: start,
    // 接口耗时
    elapsed: elapsed,
    // 接口状态
    code: xhrInstance.status,
    // 接口请求是否成功，默认成功
    success: true,
    // 每次接口请求都会改变，
    betraceid: apiCallTraceId
  });

  if (xhrInstance.status >= 400) {
    var responseText = xhrInstance.responseText;
    var resData = {};

    try {
      resData = JSON.parse(responseText);
    } catch (error) {}

    Object.assign(timingData, {
      success: false,
      reponse: resData.data || responseText,
      request: JSON.stringify(apiParams),
      msg: resData.msg
    });
  }

  timeReport(timingData);
}
/**
 * 获取上报数据
 *
 * @param {Object} fetchResponse fetch响应的实例
 * @param {Object} apiParams fetch请求的参数对象
 * @param {number} start fetch请求起始时间戳
 * @param {Object} resData 解析接口响应的json数据
 * @param {Error} jsonErr 解析json出错Error对象
 */


function reportPerfData(fetchResponse, apiParams, start) {
  var resData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var jsonErr = arguments.length > 4 ? arguments[4] : undefined;
  var apiCallTraceId = fetchResponse.headers.get(BACKEND_API_GAPM_TRACEID);
  var url = fetchResponse.url,
      ok = fetchResponse.ok,
      status = fetchResponse.status; // 在最终拿到返回的json后结束计时

  var elapsed = Date.now() - start;

  var reportData = _objectSpread(_objectSpread({}, getBasicApiTimeData()), {}, {
    // 操作名，一般取接口路径 params为发起xhr 请求时，OPEN方法的所有参数
    actionName: extractPathname(url),
    actionStart: start,
    // apicall backend tracid
    betraceid: apiCallTraceId,
    // 接口耗时
    elapsed: elapsed
  }); // http 状态码 200-299


  if (ok) {
    Object.assign(reportData, {
      code: status
    });
  } else {
    Object.assign(reportData, {
      success: false,
      code: status,
      reponse: jsonErr ? '' : JSON.stringify(resData.data),
      request: apiParams.body || JSON.stringify(apiParams.data),
      msg: jsonErr ? jsonErr.message : resData.msg
    });
  }

  timeReport(reportData);
}
/**
 * 拦截fetch接口请求后， 执行自定义的回调
 * @param {Object} fetchResponse fetch接口返回值
 * @param {Object} apiParams fetch 接口的参数
 * @param {number} start 发起请求的起始时间戳
 */


function handleFetch(fetchResponse, apiParams, _ref2) {
  var start = _ref2.start;
  // 在 fetchResponse 中的body流没有被使用之前，先克隆一份，否则会报错。
  // 参考 https://developer.mozilla.org/zh-CN/docs/Web/API/Response/clone
  var clonedRes = fetchResponse.clone(); // 异步化，不阻塞后续流程, 降低此日志优先级

  setTimeout(function () {
    if (clonedRes.headers) {
      var contentType = clonedRes.headers.get('Content-Type') || clonedRes.headers.get('content-type');
      var jsonMIME = 'application/json'; //  目前先处理返回值为 json 的数据

      if (contentType && contentType.includes(jsonMIME)) {
        clonedRes.json().then(function (resData) {
          reportPerfData(clonedRes, apiParams, start, resData);
        }, function (jsonerr) {
          reportPerfData(clonedRes, apiParams, start, {}, jsonerr);
        });
      }
    }
  }, 0);
}
/**
 * 获取上报的基础性能数据
 *
 * @returns {Object} 性能数据对象
 */


function getBasicApiTimeData() {
  var _ref3;

  // 尽量避免多次获取
  documentWidth = documentWidth || document.documentElement.clientWidth;
  documentHeight = documentHeight || document.documentElement.clientHeight; // 要上报的基础数据

  return _ref3 = {
    // 当前页 URL
    url: location.href,
    // 用户的唯一标识，由后端生成写到 cookie 中
    uuid: trackID,
    // 登录用户 id
    uid: userID,
    // 请求类型
    reqType: 'api_call',
    // appid 项目在擎天云节点树上的标识
    appNid: Config.appNid || Config.appId || Config.APPNID
  }, _defineProperty(_ref3, HB_SESSION_ID_KEY, HB_SESSION_ID_VALUE || cookie.get(HB_SESSION_ID_KEY)), _defineProperty(_ref3, "deviceResolution", "".concat(documentWidth, "*").concat(documentHeight)), _defineProperty(_ref3, "success", true), _ref3;
} // 拦截所有接口请求


export var initInterceptXHR = function initInterceptXHR() {
  // 兼容服务端
  // eslint-disable-next-line no-negated-condition
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return;
  } // 重写 xhr 的 open 方法， 拦截所有 api 请求， 统计耗时


  interceptXHR(handleXHR); // 重写 fetch 方法， 拦截所有 api 请求， 统计耗时

  interceptFetch(handleFetch); // TODO
  // if (Config.ENABLE_QINGZHOU_PERF) {
  // }
};